import React from 'react';
import { Application, Container, Graphics } from 'pixi.js';
import { Comment, CommentDrawingRef, Position } from '../../../types/typing.ts';

export const renderCommentHighlights = async (
  app: Application | null,
  comment: Comment,
  zIndex: number,
  isCommentsOpenRef: React.MutableRefObject<boolean>,
  commentContainerRef: React.MutableRefObject<Map<string, CommentDrawingRef>>
): Promise<void> => {
  const commentHiglightContainer = new Container();
  comment.pathPoints?.map((points: Position) => {
    const path = new Graphics();
    // Same colour as the pencil stroke so the committed drawing is clearly
    // visible when the playhead reaches the comment's timestamp.
    path.beginFill(0x32cd32, 1);
    path.drawCircle(points.x, points.y, 2);
    path.endFill();
    commentHiglightContainer.addChild(path);
  });

  app?.stage.addChild(commentHiglightContainer);
  commentHiglightContainer.visible = isCommentsOpenRef.current;

  const commentDrawingRef: CommentDrawingRef = {
    id: comment.id,
    pathContainer: commentHiglightContainer,
    pathPoints: comment.pathPoints,
    destroy: () => {
      app?.stage.removeChild(commentHiglightContainer);
    },
  };

  commentContainerRef.current.set(comment.id, commentDrawingRef);
  app?.stage.addChild(commentHiglightContainer);
  app?.stage.setChildIndex(commentHiglightContainer, zIndex);
};
